import ToggleMenu from 'components/token-town/toggle-menu/ToggleMenu';
import DrawInfo from '../draw-info/DrawInfo';
import PageSection from '../../page-section/PageSection';

interface InfoSectionProps {
  title: string;
  description: string;
  includes: string;
}

const InfoSection = ({ title, description, includes }: InfoSectionProps) => {
  return (
    <PageSection>
        <ToggleMenu items={[
            {
              key: 'prize-overview',
              title: 'Overview',
              body: (
                <DrawInfo title={title} description={description} />
              ),
            },
            {
              key: 'prize-description',
              title: 'Description',
              body: (
                <DrawInfo includes={includes} />
              ),
            },
          ]}
        />
    </PageSection>
  )
}

export default InfoSection;
